import {
  isProduction,
  isStage,
  isAWSProduction,
  isAWSStage,
  isAWSPlayground,
} from 'util/environment'

export const getRecaptchaKey = () => {
  const devKey = '6LeBoEkUAAAAADcNpnYIm_xXKO2p9ApuV_PHf4u9'
  const stageKey = '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI'
  const prodKey = '6LeclUkUAAAAADQ_bCfkOSQEKlbSMvwqsSQKkUPA'
  const playgroundKey = '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI'

  const prod = isProduction() || isAWSProduction()
  const stage = isStage() || isAWSStage()
  const playground = isAWSPlayground()

  if (prod) {
    return prodKey
  } else if (stage) {
    return stageKey
  } else if (playground) {
    return playgroundKey
  } else {
    return devKey
  }
}
